(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-coroutines-core.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-coroutines-core.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'androidx-lifecycle-lifecycle-viewmodel'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'androidx-lifecycle-lifecycle-viewmodel'.");
    }
    if (typeof globalThis['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'androidx-lifecycle-lifecycle-viewmodel'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'androidx-lifecycle-lifecycle-viewmodel'.");
    }
    globalThis['androidx-lifecycle-lifecycle-viewmodel'] = factory(typeof globalThis['androidx-lifecycle-lifecycle-viewmodel'] === 'undefined' ? {} : globalThis['androidx-lifecycle-lifecycle-viewmodel'], globalThis['kotlin-kotlin-stdlib'], globalThis['kotlinx-coroutines-core']);
  }
}(function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core) {
  'use strict';
  //region block: imports
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.j4;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var VOID = kotlin_kotlin.$_$.d;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var equals = kotlin_kotlin.$_$.sf;
  var hashCode = kotlin_kotlin.$_$.bg;
  var toString = kotlin_kotlin.$_$.hh;
  var objectCreate = kotlin_kotlin.$_$.dh;
  var cancel = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.j3;
  var AutoCloseable = kotlin_kotlin.$_$.wm;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.y2;
  var Dispatchers_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.h;
  var EmptyCoroutineContext_getInstance = kotlin_kotlin.$_$.q2;
  var IllegalStateException = kotlin_kotlin.$_$.in;
  var NotImplementedError = kotlin_kotlin.$_$.mn;
  var SupervisorJob = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.g3;
  var RuntimeException_init_$Create$ = kotlin_kotlin.$_$.g6;
  var Exception = kotlin_kotlin.$_$.gn;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var isInterface = kotlin_kotlin.$_$.rg;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.m4;
  var ensureNotNull = kotlin_kotlin.$_$.lo;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var UnsupportedOperationException_init_$Create$ = kotlin_kotlin.$_$.o6;
  //endregion
  //region block: pre-declaration
  function get_defaultViewModelCreationExtras() {
    return Empty_getInstance();
  }
  initMetadataForInterface(HasDefaultViewModelProviderFactory, 'HasDefaultViewModelProviderFactory');
  initMetadataForClass(ViewModelStore, 'ViewModelStore', ViewModelStore);
  initMetadataForClass(CreationExtras, 'CreationExtras');
  initMetadataForObject(Empty, 'Empty', VOID, CreationExtras);
  initMetadataForCompanion(Companion);
  initMetadataForClass(MutableCreationExtras, 'MutableCreationExtras', MutableCreationExtras_init_$Create$, CreationExtras);
  initMetadataForClass(CloseableCoroutineScope, 'CloseableCoroutineScope', VOID, VOID, [AutoCloseable, CoroutineScope]);
  initMetadataForClass(ViewModelImpl, 'ViewModelImpl', ViewModelImpl_init_$Create$);
  initMetadataForClass(ViewModelProviderImpl, 'ViewModelProviderImpl');
  initMetadataForObject(ViewModelProviders, 'ViewModelProviders');
  initMetadataForClass(ViewModel, 'ViewModel');
  initMetadataForClass(ViewModelProvider$Companion$VIEW_MODEL_KEY$$inlined$Key$1);
  function create(modelClass, extras) {
    return ViewModelProviders_instance.a8r();
  }
  initMetadataForInterface(Factory, 'Factory');
  initMetadataForClass(OnRequeryFactory, 'OnRequeryFactory');
  initMetadataForCompanion(Companion_0);
  initMetadataForClass(ViewModelProvider, 'ViewModelProvider');
  initMetadataForObject(DefaultViewModelProviderFactory, 'DefaultViewModelProviderFactory', VOID, VOID, [Factory]);
  initMetadataForClass(SynchronizedObject, 'SynchronizedObject', SynchronizedObject);
  //endregion
  function HasDefaultViewModelProviderFactory() {
  }
  function get_VIEW_MODEL_SCOPE_LOCK() {
    _init_properties_ViewModel_kt__8pkmem();
    return VIEW_MODEL_SCOPE_LOCK;
  }
  var VIEW_MODEL_SCOPE_LOCK;
  function get_viewModelScope(_this__u8e3s4) {
    _init_properties_ViewModel_kt__8pkmem();
    // Inline function 'androidx.lifecycle.viewmodel.internal.synchronized' call
    // Inline function 'androidx.lifecycle.viewmodel.internal.synchronizedImpl' call
    get_VIEW_MODEL_SCOPE_LOCK();
    var tmp0_elvis_lhs = _this__u8e3s4.a8q('androidx.lifecycle.viewmodel.internal.ViewModelCoroutineScope.JOB_KEY');
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = createViewModelScope();
      _this__u8e3s4.b8q('androidx.lifecycle.viewmodel.internal.ViewModelCoroutineScope.JOB_KEY', this_0);
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  var properties_initialized_ViewModel_kt_igete4;
  function _init_properties_ViewModel_kt__8pkmem() {
    if (!properties_initialized_ViewModel_kt_igete4) {
      properties_initialized_ViewModel_kt_igete4 = true;
      VIEW_MODEL_SCOPE_LOCK = new SynchronizedObject();
    }
  }
  function ViewModelStore() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.c8q_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(ViewModelStore).d8q = function (key, viewModel) {
    var oldViewModel = this.c8q_1.z2(key, viewModel);
    if (oldViewModel == null)
      null;
    else {
      oldViewModel.e8q();
    }
  };
  protoOf(ViewModelStore).je = function (key) {
    return this.c8q_1.w2(key);
  };
  protoOf(ViewModelStore).c3 = function () {
    var _iterator__ex2g4s = this.c8q_1.y2().t();
    while (_iterator__ex2g4s.u()) {
      var vm = _iterator__ex2g4s.v();
      vm.e8q();
    }
    this.c8q_1.c3();
  };
  function Empty() {
    Empty_instance = this;
    CreationExtras.call(this);
  }
  protoOf(Empty).g8q = function (key) {
    return null;
  };
  var Empty_instance;
  function Empty_getInstance() {
    if (Empty_instance == null)
      new Empty();
    return Empty_instance;
  }
  function Companion() {
  }
  var Companion_instance;
  function Companion_getInstance() {
    return Companion_instance;
  }
  function CreationExtras() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.h8q_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(CreationExtras).equals = function (other) {
    var tmp;
    if (other instanceof CreationExtras) {
      tmp = equals(this.h8q_1, other.h8q_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(CreationExtras).hashCode = function () {
    return hashCode(this.h8q_1);
  };
  protoOf(CreationExtras).toString = function () {
    return 'CreationExtras(extras=' + toString(this.h8q_1) + ')';
  };
  function MutableCreationExtras_init_$Init$(initialExtras, $this) {
    initialExtras = initialExtras === VOID ? Empty_getInstance() : initialExtras;
    MutableCreationExtras.call($this, initialExtras.h8q_1);
    return $this;
  }
  function MutableCreationExtras_init_$Create$(initialExtras) {
    return MutableCreationExtras_init_$Init$(initialExtras, objectCreate(protoOf(MutableCreationExtras)));
  }
  function MutableCreationExtras(initialExtras) {
    CreationExtras.call(this);
    // Inline function 'kotlin.collections.plusAssign' call
    this.h8q_1.b3(initialExtras);
  }
  protoOf(MutableCreationExtras).j8q = function (key, t) {
    // Inline function 'kotlin.collections.set' call
    this.h8q_1.z2(key, t);
  };
  protoOf(MutableCreationExtras).g8q = function (key) {
    return this.h8q_1.w2(key);
  };
  function CloseableCoroutineScope(coroutineContext) {
    this.k8q_1 = coroutineContext;
  }
  protoOf(CloseableCoroutineScope).q19 = function () {
    return this.k8q_1;
  };
  protoOf(CloseableCoroutineScope).j4 = function () {
    return cancel(this.k8q_1);
  };
  function createViewModelScope() {
    var tmp;
    try {
      tmp = Dispatchers_getInstance().m1h().o1l();
    } catch ($p) {
      var tmp_0;
      if ($p instanceof NotImplementedError) {
        var _unused_var__etf5q3 = $p;
        tmp_0 = EmptyCoroutineContext_getInstance();
      } else {
        if ($p instanceof IllegalStateException) {
          var _unused_var__etf5q3_0 = $p;
          tmp_0 = EmptyCoroutineContext_getInstance();
        } else {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    var dispatcher = tmp;
    return new CloseableCoroutineScope(dispatcher.xj(SupervisorJob()));
  }
  function ViewModelImpl_init_$Init$($this) {
    ViewModelImpl.call($this);
    return $this;
  }
  function ViewModelImpl_init_$Create$() {
    return ViewModelImpl_init_$Init$(objectCreate(protoOf(ViewModelImpl)));
  }
  function closeWithRuntimeException($this, closeable) {
    try {
      if (closeable == null)
        null;
      else {
        closeable.j4();
      }
    } catch ($p) {
      if ($p instanceof Exception) {
        var e = $p;
        throw RuntimeException_init_$Create$(e);
      } else {
        throw $p;
      }
    }
  }
  protoOf(ViewModelImpl).c3 = function () {
    if (this.o8q_1)
      return Unit_instance;
    this.o8q_1 = true;
    // Inline function 'androidx.lifecycle.viewmodel.internal.synchronized' call
    // Inline function 'androidx.lifecycle.viewmodel.internal.synchronizedImpl' call
    this.l8q_1;
    var _iterator__ex2g4s = this.m8q_1.y2().t();
    while (_iterator__ex2g4s.u()) {
      var closeable = _iterator__ex2g4s.v();
      closeWithRuntimeException(this, closeable);
    }
    var _iterator__ex2g4s_0 = this.n8q_1.t();
    while (_iterator__ex2g4s_0.u()) {
      var closeable_0 = _iterator__ex2g4s_0.v();
      closeWithRuntimeException(this, closeable_0);
    }
    this.n8q_1.c3();
  };
  protoOf(ViewModelImpl).b8q = function (key, closeable) {
    if (this.o8q_1) {
      closeWithRuntimeException(this, closeable);
      return Unit_instance;
    }
    // Inline function 'androidx.lifecycle.viewmodel.internal.synchronized' call
    // Inline function 'androidx.lifecycle.viewmodel.internal.synchronizedImpl' call
    this.l8q_1;
    var oldCloseable = this.m8q_1.z2(key, closeable);
    closeWithRuntimeException(this, oldCloseable);
  };
  protoOf(ViewModelImpl).p8q = function (closeable) {
    if (this.o8q_1) {
      closeWithRuntimeException(this, closeable);
      return Unit_instance;
    }
    // Inline function 'androidx.lifecycle.viewmodel.internal.synchronized' call
    // Inline function 'androidx.lifecycle.viewmodel.internal.synchronizedImpl' call
    this.l8q_1;
    // Inline function 'kotlin.collections.plusAssign' call
    this.n8q_1.j1(closeable);
  };
  protoOf(ViewModelImpl).a8q = function (key) {
    // Inline function 'androidx.lifecycle.viewmodel.internal.synchronized' call
    // Inline function 'androidx.lifecycle.viewmodel.internal.synchronizedImpl' call
    this.l8q_1;
    var tmp = this.m8q_1.w2(key);
    return (tmp == null ? true : isInterface(tmp, AutoCloseable)) ? tmp : THROW_CCE();
  };
  function ViewModelImpl() {
    this.l8q_1 = new SynchronizedObject();
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.m8q_1 = LinkedHashMap_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp_0.n8q_1 = LinkedHashSet_init_$Create$();
    this.o8q_1 = false;
  }
  function ViewModelProviderImpl(store, factory, defaultExtras) {
    this.q8q_1 = store;
    this.r8q_1 = factory;
    this.s8q_1 = defaultExtras;
    this.t8q_1 = new SynchronizedObject();
  }
  protoOf(ViewModelProviderImpl).u8q = function (modelClass, key) {
    // Inline function 'androidx.lifecycle.viewmodel.internal.synchronized' call
    // Inline function 'androidx.lifecycle.viewmodel.internal.synchronizedImpl' call
    this.t8q_1;
    var tmp$ret$2;
    $l$block: {
      var viewModel = this.q8q_1.je(key);
      if (modelClass.ob(viewModel)) {
        var tmp = this.r8q_1;
        if (tmp instanceof OnRequeryFactory) {
          this.r8q_1.v8q(ensureNotNull(viewModel));
        }
        tmp$ret$2 = viewModel instanceof ViewModel ? viewModel : THROW_CCE();
        break $l$block;
      }
      var modelExtras = MutableCreationExtras_init_$Create$(this.s8q_1);
      modelExtras.j8q(Companion_getInstance_0().w8q_1, key);
      // Inline function 'kotlin.also' call
      var this_0 = createViewModel(this.r8q_1, modelClass, modelExtras);
      this.q8q_1.d8q(key, this_0);
      tmp$ret$2 = this_0;
    }
    return tmp$ret$2;
  };
  protoOf(ViewModelProviderImpl).x8q = function (modelClass, key, $super) {
    key = key === VOID ? ViewModelProviders_instance.z8q(modelClass) : key;
    return $super === VOID ? this.u8q(modelClass, key) : $super.u8q.call(this, modelClass, key);
  };
  function ViewModelProviders() {
    this.y8q_1 = 'androidx.lifecycle.ViewModelProvider.DefaultKey';
  }
  protoOf(ViewModelProviders).z8q = function (modelClass) {
    var tmp0 = get_canonicalName(modelClass);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (tmp0 == null) {
        var message = 'Local and anonymous classes can not be ViewModels';
        throw IllegalArgumentException_init_$Create$(toString(message));
      } else {
        tmp$ret$0 = tmp0;
        break $l$block;
      }
    }
    var canonicalName = tmp$ret$0;
    return 'androidx.lifecycle.ViewModelProvider.DefaultKey:' + canonicalName;
  };
  protoOf(ViewModelProviders).a8r = function () {
    throw UnsupportedOperationException_init_$Create$('`Factory.create(String, CreationExtras)` is not implemented. You may need to override the method and provide a custom implementation. Note that using `Factory.create(String)` is not supported and considered an error.');
  };
  protoOf(ViewModelProviders).b8r = function (owner) {
    var tmp;
    if (isInterface(owner, HasDefaultViewModelProviderFactory)) {
      tmp = owner.x8p();
    } else {
      tmp = DefaultViewModelProviderFactory_instance;
    }
    return tmp;
  };
  protoOf(ViewModelProviders).c8r = function (owner) {
    var tmp;
    if (isInterface(owner, HasDefaultViewModelProviderFactory)) {
      tmp = owner.y8p();
    } else {
      tmp = Empty_getInstance();
    }
    return tmp;
  };
  var ViewModelProviders_instance;
  function ViewModelProviders_getInstance() {
    return ViewModelProviders_instance;
  }
  function ViewModel_init_$Init$($this) {
    ViewModel.call($this);
    $this.z8p_1 = ViewModelImpl_init_$Create$();
    return $this;
  }
  protoOf(ViewModel).d8r = function () {
  };
  protoOf(ViewModel).e8q = function () {
    this.z8p_1.c3();
    this.d8r();
  };
  protoOf(ViewModel).b8q = function (key, closeable) {
    this.z8p_1.b8q(key, closeable);
  };
  protoOf(ViewModel).p8q = function (closeable) {
    this.z8p_1.p8q(closeable);
  };
  protoOf(ViewModel).a8q = function (key) {
    return this.z8p_1.a8q(key);
  };
  function ViewModel() {
  }
  function ViewModelProvider$Companion$VIEW_MODEL_KEY$$inlined$Key$1() {
  }
  function Factory() {
  }
  function OnRequeryFactory() {
  }
  protoOf(OnRequeryFactory).v8q = function (viewModel) {
  };
  function Companion_0() {
    Companion_instance_0 = this;
    var tmp = this;
    // Inline function 'androidx.lifecycle.viewmodel.Companion.Key' call
    tmp.w8q_1 = new ViewModelProvider$Companion$VIEW_MODEL_KEY$$inlined$Key$1();
  }
  protoOf(Companion_0).f8r = function (owner, factory, extras) {
    return new ViewModelProvider(new ViewModelProviderImpl(owner.g8r(), factory, extras));
  };
  protoOf(Companion_0).h8r = function (owner, factory, extras, $super) {
    factory = factory === VOID ? ViewModelProviders_instance.b8r(owner) : factory;
    extras = extras === VOID ? ViewModelProviders_instance.c8r(owner) : extras;
    return $super === VOID ? this.f8r(owner, factory, extras) : $super.f8r.call(this, owner, factory, extras);
  };
  protoOf(Companion_0).i8r = function (store, factory, extras) {
    return new ViewModelProvider(new ViewModelProviderImpl(store, factory, extras));
  };
  var Companion_instance_0;
  function Companion_getInstance_0() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function ViewModelProvider(impl) {
    Companion_getInstance_0();
    this.j8r_1 = impl;
  }
  protoOf(ViewModelProvider).k8r = function (modelClass) {
    return this.j8r_1.x8q(modelClass);
  };
  protoOf(ViewModelProvider).l8r = function (key, modelClass) {
    return this.j8r_1.u8q(modelClass, key);
  };
  function DefaultViewModelProviderFactory() {
  }
  protoOf(DefaultViewModelProviderFactory).e8r = function (modelClass, extras) {
    return ViewModelProviders_instance.a8r();
  };
  var DefaultViewModelProviderFactory_instance;
  function DefaultViewModelProviderFactory_getInstance() {
    return DefaultViewModelProviderFactory_instance;
  }
  function createViewModel(factory, modelClass, extras) {
    return factory.e8r(modelClass, extras);
  }
  function get_canonicalName(_this__u8e3s4) {
    return _this__u8e3s4 == null ? null : _this__u8e3s4.o();
  }
  function SynchronizedObject() {
  }
  //region block: init
  Companion_instance = new Companion();
  ViewModelProviders_instance = new ViewModelProviders();
  DefaultViewModelProviderFactory_instance = new DefaultViewModelProviderFactory();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = HasDefaultViewModelProviderFactory;
  _.$_$.b = create;
  _.$_$.c = Factory;
  _.$_$.d = ViewModelStore;
  _.$_$.e = ViewModel;
  _.$_$.f = get_viewModelScope;
  _.$_$.g = Companion_instance;
  _.$_$.h = Empty_getInstance;
  _.$_$.i = Companion_getInstance_0;
  _.$_$.j = MutableCreationExtras_init_$Create$;
  _.$_$.k = ViewModel_init_$Init$;
  //endregion
  return _;
}));

//# sourceMappingURL=androidx-lifecycle-lifecycle-viewmodel.js.map
